
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import React, { useState, useEffect, Fragment, useMemo } from "react";

interface PrivacyPolicyProps {
    open: boolean;    
    handleClose: () => void;
}

export default function PrivacyPolicy({open,handleClose}:PrivacyPolicyProps) {
  return (
    <Fragment>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Privacy Policy</DialogTitle>
        {/* <DialogContent>                                                */}            
            <iframe src="./privacy.pdf" width={500} height={350} />                                                                                      
        {/* </DialogContent> */}
        <DialogActions>
          <Button variant="outlined" onClick={handleClose}>
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  )
}